import { render } from "./Switcher.vue?vue&type=template&id=3c86fa8f&ts=true"
import script from "./Switcher.vue?vue&type=script&lang=ts"
export * from "./Switcher.vue?vue&type=script&lang=ts"

import "./Switcher.vue?vue&type=style&index=0&id=3c86fa8f&lang=scss"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/marlu-store-locator-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__